import { render, staticRenderFns } from "./NativeScorecardSection.vue?vue&type=template&id=5a15b57c&scoped=true"
import script from "./NativeScorecardSection.vue?vue&type=script&lang=js"
export * from "./NativeScorecardSection.vue?vue&type=script&lang=js"
import style0 from "./NativeScorecardSection.vue?vue&type=style&index=0&id=5a15b57c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a15b57c",
  null
  
)

export default component.exports